<template>
  <div class="admin-wrapper edit-user">
    <section class="hero is-small">
      <div class="hero-body">
        <!-- DANGER ZONE -->
        <div class="danger-zone">
          <h1 class="title is-1">Account: {{ user.email }}</h1>
          <p>
            Please double check the user name above to ensure you're editing the
            correct account. If this is a premium account, you should not delete
            the user record.
          </p>
          <br />
          <pre>
            <b>Email:</b>  {{user.email}}<br />
            <b>Video Plan:</b> {{user.products.video}}<br />
            <b>Link Plan:</b> {{user.products.link}}
          </pre>
          <br />
          <h1 class="title">DANGER ZONE</h1>
          <div class="danger-buttons">
            <el-button type="info" @click="launchPasswordModal()"
              >RESET Password</el-button
            >
            <el-button type="warning" @click="launchPlanModal()"
              >CHANGE User Plan Name</el-button
            >
            <el-button type="warning" @click="launchPausePlanModal()"
              >PAUSE User Plan</el-button
            >
            <el-button type="warning" @click="launchCancelPlanModal()"
              >CANCEL User Plan</el-button
            >
            <el-button type="danger" @click="launchDeleteModal()"
              >DELETE User Record</el-button
            >
          </div>
        </div>
      </div>
    </section>
    <br />
    <br />

    <!-- DELETE USER -->
    <el-dialog title="DELETE USER" :visible.sync="deleteModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b>
          {{ user.email }}
          <br />
          <b>Video Plan:</b>
          {{ user.products.video }}
          <br />
          <b>Link Plan:</b>
          {{ user.products.link }}
        </el-form-item>
        <el-form-item label="Notes">
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div v-if="user.products">
        <div
          class="tip danger"
          v-if="user.products.video !== 'free' || user.products.link !== 'free'"
        >
          Warning: This user still has a subscription attached. Do not delete
          until this has been addressed.
        </div>
      </div>
      <div class="tip danger">
        Warning:
        <b>{{ user.email }}</b> will be permanently deleted.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" class="has-margin-left" @click="deleteUser()"
          >DELETE</el-button
        >
      </div>
    </el-dialog>

    <!-- RESET PASSWORD -->
    <el-dialog title="Reset Password" :visible.sync="passwordModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b>
          {{ user.email }}
          <br />
          <b>Video Plan:</b>
          {{ user.products.video }}
          <br />
          <b>Link Plan:</b>
          {{ user.products.link }}
        </el-form-item>
        <el-form-item label="Notes">
          <el-input
            v-model="newPassword"
            class="has-small-margin-top"
            placeholder="New Password"
          ></el-input>
          <el-input
            v-model="confirmNewPassword"
            class="has-small-margin-top"
            placeholder="Confirm New Password"
          ></el-input>
          <br />
          <br />
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div class="tip danger">
        Warning:
        <b>{{ user.email }}</b
        >'s password will be changed immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          class="has-margin-left"
          @click="updateUserPassword()"
          >RESET PASSWORD</el-button
        >
      </div>
    </el-dialog>

    <!-- CHANGE PLAN -->
    <el-dialog title="Change Plan" :visible.sync="planModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b> {{ user.email }} <br />
          <b>Video Plan:</b> {{ user.products.video }} <br />
          <b>Link Plan:</b> {{ user.products.link }}
        </el-form-item>
        <el-form-item label="Notes">
          <el-select v-model="newPlan" placeholder="New Plan">
            <el-option
              v-for="item in plans"
              :key="item.id"
              :label="`${item.name} ($${item.amount / 100}/${item.interval})`"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div class="tip danger">
        Warning: <b>{{ user.email }}</b
        >'s plan will be changed immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          class="has-margin-left"
          @click="updateUserPlanName()"
          >CHANGE PLAN</el-button
        >
      </div>
    </el-dialog>

    <!-- PAUSE PLAN -->
    <el-dialog title="Pause Plan" :visible.sync="pausePlanModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b> {{ user.email }} <br />
          <b>Video Plan:</b> {{ user.products.video }} <br />
          <b>Link Plans:</b> {{ user.products.link }}
        </el-form-item>
        <el-form-item label="Notes">
          <el-radio-group v-model="pausePlanDuration" size="mini">
            <el-radio-button label="0">active</el-radio-button>
            <el-radio-button label="1">1 month</el-radio-button>
            <el-radio-button label="2">2 months</el-radio-button>
            <el-radio-button label="3" disabled>3 months</el-radio-button>
          </el-radio-group>
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div class="tip danger">
        Warning: <b>{{ user.email }}</b
        >'s plan will be changed immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          class="has-margin-left"
          @click="pauseUserPlan()"
          >PAUSE PLAN</el-button
        >
      </div>
    </el-dialog>

    <!-- CANCEL PLAN -->
    <el-dialog title="Cancel Plan" :visible.sync="cancelPlanModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b> {{ user.email }} <br />
          <b>Video Plan:</b> {{ user.products.video }} <br />
          <b>Link Plans:</b> {{ user.products.link }}
        </el-form-item>
        <el-form-item label="Notes">
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div class="tip danger">
        Warning: <b>{{ user.email }}</b
        >'s plan will be cancelled immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          class="has-margin-left"
          @click="cancelUserPlan()"
          >CANCEL PLAN</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AdminService from '@/api/admin.service';
import '@/style/admin.scss';
import moment from 'moment';

export default {
  name: 'Settings',
  data() {
    return {
      newPassword: '',
      confirmNewPassword: '',
      user: this.$store.state.user,
      passwordModalVisible: false,
      deleteModalVisible: false,
      planModalVisible: false,
      pausePlanModalVisible: false,
      cancelPlanModalVisible: false,
      editReason: '',
      me: this.$store.state.user,
      plans: [],
      newPlan: '',
      pausePlanDuration: '',
    };
  },

  created() {
    this.getUser();
    this.forceLoadNewState();
    this.getBillingOptions();
    this.getBillingStatus();
  },

  methods: {
    async getBillingOptions() {
      const plans = await AdminService.getBillingOptions();
      const freePlan = {
        active: true,
        aggregate_usage: null,
        amount: 0,
        amount_decimal: '0',
        billing_scheme: 'per_unit',
        created: 1568406055,
        currency: 'usd',
        id: 'free',
        interval: 'month',
        interval_count: 1,
        livemode: false,
        metadata: {},
        name: 'free',
        nickname: 'Free',
        object: 'plan',
        product: '',
        statement_descriptor: null,
        tiers: null,
        tiers_mode: null,
        transform_usage: null,
        trial_period_days: null,
        usage_type: 'licensed',
      };
      plans.push(freePlan);
      this.plans = plans.sort((a, b) => {
        const planA = a.id.toUpperCase();
        const planB = b.id.toUpperCase();

        // eslint-disable-next-line no-nested-ternary
        return planA < planB ? -1 : planA > planB ? 1 : 0;
      });
    },

    async getBillingStatus() {
      const id = window.location.pathname.split('/')[2];
      this.billingStatus = await AdminService.getBillingStatus(id);
    },

    launchDeleteModal() {
      this.deleteModalVisible = true;
    },

    launchPasswordModal() {
      this.passwordModalVisible = true;
    },

    launchPlanModal() {
      this.planModalVisible = true;
    },

    launchPausePlanModal() {
      this.pausePlanModalVisible = true;
    },

    launchCancelPlanModal() {
      this.cancelPlanModalVisible = true;
    },

    async getUser() {
      const id = window.location.pathname.split('/')[2];
      this.user = await AdminService.getUser(id);
    },

    async forceLoadNewState() {
      await this.$store.dispatch('SYNC_USER_TO_DB');
    },

    async updateUserPassword() {
      if (this.newPassword !== this.confirmNewPassword) {
        this.$message.error({ message: 'Your passwords did not match.' });
        return;
      }

      // Safety check for admin to confirm correct user's password being reset
      try {
        const message = 'You are about to reset the password for:'
          + `<pre><strong>${this.user.email}</strong></pre><br>`
          + '<strong>Double check the user name before proceeding.</strong>';
        const confirmData = {
          confirmButtonText: 'Reset Password',
          cancelButtonText: 'Nevermind',
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(message, 'DANGER: PASSWORD RESET', confirmData);
      } catch (err) {
        this.$message.error({
          message: `Abandoned password change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with password reset request
      try {
        // add action.message
        const payload = {
          newPassword: this.newPassword,
          message: this.editReason,
        };
        await AdminService.updateUserPassword(this.user._id, payload);
        await this.$store.dispatch('SYNC_USER_TO_DB');
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.$message.success({
          message: `${this.user.email}'s password was updated.`,
        });
        this.passwordModalVisible = false;
      } catch (err) {
        if (err.response && err.response.data) {
          this.$message.error({ message: err.response.data.message });
        } else {
          this.$message.error({ message: 'Unable to change password' });
        }
      }
    },

    async updateUserPlanName() {
      console.log('user ----------------');
      console.log(this.user);
      if (this.newPassword !== this.confirmNewPassword) {
        this.$message.error({ message: 'Your passwords did not match.' });
        return;
      }

      // Safety check for admin to confirm correct user's plan being set
      try {
        const message = 'You are about to update the plan name for:'
          + `<pre><strong>${this.user.email}</strong></pre><br>`
          + `<pre>to <strong>${this.newPlan}</strong></pre><br>`
          + '<strong>Double check the user name and plan before proceeding.</strong>';
        const confirmData = {
          confirmButtonText: 'Change Plan',
          cancelButtonText: 'Nevermind',
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(message, 'DANGER: PLAN CHANGE', confirmData);
      } catch (err) {
        this.$message.error({
          message: `Abandoned plan change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with plan change request
      try {
        // add action.message
        await AdminService.updateUserPlanName(this.user._id, {
          planName: this.newPlan,
        });
        await this.$store.dispatch('SYNC_USER_TO_DB');
        this.newPlan = '';
        this.$message.success({
          message: `${this.user.email}'s plan was updated.`,
        });
        this.passwordModalVisible = false;
      } catch (err) {
        this.$message.error({ message: 'Your old password was wrong.' });
      }
    },

    async pauseUserPlan() {
      const duration = this.pausePlanDuration;
      const { current_period_end } = this.billingStatus.find(
        x => x.plan.id.indexOf('link') === -1
      );
      const stopDate = moment(current_period_end * 1000);
      const resumeDate = moment(current_period_end * 1000).add(
        duration,
        'month'
      );
      const data = {
        stopDate,
        resumeDate,
        duration,
        event: 'pause',
        message: this.editReason,
      };

      // Safety check for admin to confirm correct user's plan being set
      try {
        const message = 'You are about to pause the plan for:'
          + `<pre><strong>${this.user.email}</strong></pre><br>`
          + `<pre>starting from <strong>${stopDate}</strong></pre><br>`
          + `<pre>will continue on <strong>${resumeDate}</strong></pre><br>`
          + '<strong>Double check the user name and plan before proceeding.</strong>';
        const confirmData = {
          confirmButtonText: 'Pause Plan',
          cancelButtonText: 'Nevermind',
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(message, 'DANGER: PAUSE PLAN', confirmData);
      } catch (err) {
        this.$message.error({
          message: `Abandoned plan change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with plan pause request
      try {
        await AdminService.updateUser(this.user._id, data);
        this.$notify.success({ title: 'Success', message: 'pause complete' });
        this.pausePlanModalVisible = false;
      } catch (err) {
        this.$notify.error({ title: 'Error', message: 'pause failed' });
      }
    },

    async cancelUserPlan() {
      // Safety check for admin to confirm correct user's plan being set

      const videoPlan = this.billingStatus.find(
        x => x.plan.id.indexOf('link') === -1
      );
      const stopDate = new Date(videoPlan.current_period_end * 1000);
      const data = {
        event: 'cancel',
        planType: 'video',
        stopDate,
        message: this.editReason,
      };

      try {
        const message = 'You are about to cancel the plan for:'
          + `<pre><strong>${this.user.email}</strong></pre><br>`
          + `<pre>Video plan: <strong>${this.user.products.video}</strong></pre><br>`
          + `<pre>Ends on: <strong>${stopDate}</strong></pre><br>`
          + '<strong>Double check the user name and plan before proceeding.</strong>';
        const confirmData = {
          confirmButtonText: 'Cancel Plan',
          cancelButtonText: 'Nevermind',
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(message, 'DANGER: CANCEL PLAN', confirmData);
      } catch (err) {
        this.$message.error({
          message: `Abandoned plan change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with plan pause request
      try {
        await AdminService.updateUser(this.user._id, data);
        this.$notify.success({
          title: 'Success',
          message: 'Cancel plan complete',
        });
        this.cancelPlanModalVisible = false;
      } catch (err) {
        this.$notify.error({ title: 'Error', message: 'Cancel plan failed' });
      }
    },
    async deleteUser() {
      const payload = {
        email: `DELETE-${Date.now()}`,
        message: this.editReason,
      };
      await AdminService.deleteUser(this.user._id, payload);
      this.deleteModalVisible = false;
      this.$message.success({ message: 'User deleted' });
    },
  },
};
</script>

<style>
.danger-zone p {
  text-align: center;
}

.danger-zone button {
  margin: 0 auto;
  display: block;
  width: 200px;
  margin-top: 1em;
}

.danger-buttons button {
  margin: 0 auto !important;
  margin-top: 2em !important;
}

pre * {
  font-size: 18px;
}

.edit-user .hero {
  background-color: #fff;
  background: #fff;
}
</style>
